import React from 'react';
import { InternalSignatureDocumentDefinition } from '@dill/dill-shared';
import { DillButton, DillModal } from '../../../general/Dill';
import InternalSignatureDocumentsSection, {
  CreditApplicationFieldChoiceGroup,
} from './InternalSignatureDocumentsSection';

// Edits local state only — same convention as AddStepModal/CreditApplicationFieldsModal in this
// builder: changes are held in the page's own `internalSignatureDocuments` state and only actually persisted
// when the page's own Submit button dispatches the full template.
const InternalSignatureDocumentsModal = ({
  open,
  handleClose,
  internalSignatureDocuments,
  onChange,
  creditApplicationFieldChoices,
}: {
  open: boolean;
  handleClose: () => void;
  internalSignatureDocuments: InternalSignatureDocumentDefinition[];
  onChange: (forms: InternalSignatureDocumentDefinition[]) => void;
  creditApplicationFieldChoices?: CreditApplicationFieldChoiceGroup[];
}) => {
  return (
    <DillModal
      open={open}
      onClose={handleClose}
      title="Internal Signature Documents"
      maxWidth="720px"
      footer={
        <div className="flex justify-end w-full">
          <DillButton label="Done" onClick={handleClose} />
        </div>
      }>
      <InternalSignatureDocumentsSection
        internalSignatureDocuments={internalSignatureDocuments}
        onChange={onChange}
        creditApplicationFieldChoices={creditApplicationFieldChoices}
      />
    </DillModal>
  );
};

export default InternalSignatureDocumentsModal;
